export const ECommerceInvoiceCreate = {
  url: '/api/invoice',
  method: 'POST'
} as const;

export const ECommerceInquiry = {
  url: '/api/inquiry',
  method: 'POST'
} as const;

export const ECommercePayByToken = {
  url: '/api/pay',
  method: 'POST'
} as const; 